<template>
	<div class="nav">
		<div class="nav-left">
			<img class="logo" src="../../public/img/logo.png" />
		</div>
		<div class="nav-right">
			<div class="nav-right-left">
				<div class="home">
					<router-link to="/">
						<div style="color: aliceblue;">即时通讯云</div>
					</router-link>
				</div>
				<div class="docu">
					<router-link to="/test">
						<div style="color: aliceblue;">文档</div>
					</router-link>
				</div>
				<div class="docu">
						<a href="./dist/index.html" target="_blank" rel="noopener noreferrer" style="color: aliceblue;font-size: 13px;">控制台</a>
				</div>
			</div>
			<div class="nav-right-right">
				<div class="regist">
						<a style="color: #222200;font-size: 13px;" @click="login()">{{txt}}</a>
				</div>
				<!-- <div class="regist">
					<router-link to="/test">
						<div style="color: #222200;font-size: 13px;">测试</div>
						</router-link>
				</div> -->
			</div>
		</div>
		
		<el-dialog title="登陆" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<div class="form">
				<div class="item">
					<div class="txt">账号</div>
					<div class="input-box">
						<input v-model="name" type="text" />
					</div>
				</div>
				<div class="item">
					<div class="txt">密码</div>
					<div class="input-box">
						<input v-model="pwd" type="password" />
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="tologin()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import myfun from '../assets/myfun.js';
	export default {
		data(){
			return {
				txt:'登陆',
				dialogVisible: false,
				name:'',
				pwd:''
			}
		},
		created() {
			let name = this.$cookies.get('PHPSESSID')
			console.log(name)
			if(name==''||name==null||name==undefined){
				this.txt='登陆'
			}else{
				this.txt='退出'
			}
		},
		mounted() {
			myfun.$on('login',res=>{
				console.log(123)
			})
		},
		methods:{
			admin(){
				let name = this.$cookies.get('PHPSESSID')
				console.log(name)
				if(name==''||name==null||name==undefined){
					this.dialogVisible = true
				}else{
					this.$router.push('/apply')
				}
			},
			tologin(){
				if(this.name==''||this.pwd==""){
					this.$message('用户名或密码填写错误');
					return
				}
				this.$http.post('index/getUserToken', {
					uname:this.name,
					pwd:this.pwd
				}).then(res => {
					console.log(res)
					if(res.status==200){
						this.$message('登陆成功');
						localStorage.setItem('name',this.name)
						this.$cookies.set('PHPSESSID',res.session)
						this.$router.push('/apply')
					}else{
						this.$message('用户名或密码填写错误');
					}
					this.dialogVisible = false
				}).catch(err => {
					console.log(err)
					this.dialogVisible = false
					this.$message('w网络错误');
				})
			},
			handleClose(done) {
				this.$confirm('确认取消登陆吗？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			textlogin(){
				window.open("./dist/index.html","_blank");
			},
			login(){
				if(this.txt=='登陆'){
					window.open("./dist/index.html","_blank");
					
				}else{
					this.$http.post('index/logout',{}).then(res => {
						console.log(res)
						this.$cookies.remove('PHPSESSID')
						this.$router.go(0)
					}).catch(error => {
					  console.log(error)
					})
				}
			}
		}
	}
</script>

<style scoped="scoped">
	
	a{
		text-decoration: none;
		font-size:13px;
	}
	.btn2 {
		width: 150px;
		height: 40px;
		font-size: 15px;
		color: white;
		text-align: center;
		line-height: 40px;
		border-radius: 5px;
		margin-left: 10px;
	}
	
	.btn1 {
		background-color: white;
		color: black;
		margin-right: 20px;
		color: #0f73ee;
	}
	
	.btn2 {
		background-color: #fa9630;
	}
	.txt{
		font-size: 15px;
	}
	.txt1{
		width: 100px;
		height: 100px;
	}
	.item{
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin: 20px;
	}
	.item1{
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content:flex-end;
	}
	.input-box{
		width: 60%;
		border-bottom: 1px solid #222200;
	}
	.form{
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	input{
		border: 0px;
		outline: none;
	}
	.bg{
		width: 100vw;
		height: 100vh;
		background-color: #0f73ee;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.form{
		width: 100%;
		height: 40%;
		background-color: white;
		border-radius: 5px;
	}
	a{
		text-decoration: none;
		font-size:13px;
	}
	.nav,.nav-left ,.nav-right ,.nav-right-left ,.nav-right-right{
		
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
		height: 100%;
		overflow: hidden;
	}
	.logo{
		width: 85px;
		height: 30px;
	}
	.logo-txt{
		color: white;
		margin-left: 20px;
		font-size: 30px;
		font-weight: 500;
	}
	.nav{
		width: 100vw;
		height: 8vh;
		background-color: #222200;
		overflow: hidden;
	}
	
	.nav-right{
		width: 500px;
	}
	.nav-left{
		margin-left: 200px;
	}
	.nav-right-left{
		width: 200px;
	}
	.nav-right-right{
		width: 150px;
	}
	.login,.regist{
		width: 50px;
		height: 25px;
		text-align: center;
		line-height: 25px;
		border-radius: 3px;
		border:  1px solid white;
	}
	.regist{
		background-color: white;
		color: #222200;
	}
	.regist:hover {
		cursor: pointer;
	}
	.docu:hover {
		cursor: pointer;
	}
</style>
